import React from "react";
import { useState } from "react";
import { Card, Row, Col } from "antd";
import {
  Faqtable,
  ModuleTopHeading,
} from "../../components";
const Faq = () => {
  const [visible, setVisible] = useState(false);
  
  return (
    <>
      <Card className="shadow-d radius-12">
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <ModuleTopHeading
              level={5}
              name="Faqs"
              onClick={() => setVisible(true)}
            />
          </Col>
          <Col span={24}>
            <Faqtable {...{visible, setVisible}} />
          </Col>
        </Row>
      </Card>
      
    </>
  );
};

export { Faq };
